import React, { FC, ReactNode, createContext, useContext } from 'react';
import type { DrawingSession } from './hooks/useDrawingSession';

/**
 * Context that exposes the lifted `useDrawingSession` state. ImageHandling owns the session
 * (so all hooks live at one place); Picture's annotation overlay slot AND DrawingCanvas's
 * chrome both consume from here, sharing the same single source of truth.
 */
const DrawingSessionContext = createContext<DrawingSession | null>(null);

export const DrawingSessionProvider: FC<{ session: DrawingSession; children: ReactNode }> = ({ session, children }) => (
  <DrawingSessionContext.Provider value={session}>{children}</DrawingSessionContext.Provider>
);

export const useDrawingSessionContext = (): DrawingSession => {
  const ctx = useContext(DrawingSessionContext);
  if (!ctx) throw new Error('useDrawingSessionContext must be used inside <DrawingSessionProvider>');
  return ctx;
};

/** Returns null if there's no active session (e.g. the consumer mounts outside annotation mode). */
export const useOptionalDrawingSession = (): DrawingSession | null => useContext(DrawingSessionContext);
